import { buildModelManager } from "../builder.js";
const DefaultPreceptorEvaluationSelection = {
  __typename: true,
  id: true,
  approachableAvailable: true,
  clarifiedExpectations: true,
  clinicalSite: true,
  comments: { markdown: true, truncatedHTML: true },
  createdAt: true,
  flaggedForReview: true,
  opportunitiesProvided: true,
  overallRating: true,
  patientContactRelevant: true,
  preceptorId: true,
  professionalBehavior: true,
  providedFeedback: true,
  reviewDate: true,
  reviewNotes: { markdown: true, truncatedHTML: true },
  reviewedById: true,
  rotationDate: true,
  shiftId: true,
  siteBeneficial: true,
  siteCleanAdequate: true,
  studentId: true,
  studentLevel: true,
  submittedAt: true,
  updatedAt: true,
  wouldRecommendPreceptor: true,
  wouldRecommendSite: true
};
const modelApiIdentifier = "preceptorEvaluation";
const pluralModelApiIdentifier = "preceptorEvaluations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPreceptorEvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPreceptorEvaluation",
    operationReturnType: "CreatePreceptorEvaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      preceptorEvaluation: { required: false, type: "CreatePreceptorEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePreceptorEvaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreatePreceptorEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "action",
    operationName: "updatePreceptorEvaluation",
    operationReturnType: "UpdatePreceptorEvaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      preceptorEvaluation: { required: false, type: "UpdatePreceptorEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePreceptorEvaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdatePreceptorEvaluationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "action",
    operationName: "deletePreceptorEvaluation",
    operationReturnType: "DeletePreceptorEvaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePreceptorEvaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertPreceptorEvaluation",
    operationReturnType: "UpsertPreceptorEvaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      preceptorEvaluation: { required: false, type: "UpsertPreceptorEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePreceptorEvaluationResult": { hasReturnType: false },
      "... on UpdatePreceptorEvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPreceptorEvaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertPreceptorEvaluationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPreceptorEvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "preceptorEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PreceptorEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPreceptorEvaluationSelection,
  operations
);
export {
  DefaultPreceptorEvaluationSelection,
  PreceptorEvaluationManager
};
//# sourceMappingURL=PreceptorEvaluation.js.map
